import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { WbsService } from '../proxy/controlling/controllers/wbs.service';
import { ActivityPerStage } from '@controlling/activity-per-stage/activity-per-stage';
import { LevelPerActivity } from '@controlling/level-per-activity/level-per-activity';
import { DocumentTypePerActivity } from '@controlling/document-type-per-activity/document-type-per-activity';
import { ActivityProcessParametrization } from '@controlling/activity-process-parametrization/activity-process-parametrization';
import { ConsumableAcceptedPerActivity } from '@controlling/consumable-accepted-per-activity/consumable-accepted-per-activity';

FieldBuilder.setNamespace('Controlling');

export const ACTIVITY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Activity.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .checkbox('isDirect', 'Entity.Activity.IsDirect')
    .build(),
  FieldBuilder
    .checkbox('shouldCheckDocumentation', 'Entity.Activity.ShouldCheckDocumentation')
    .build(),
  FieldBuilder
    .checkbox('hasSpecificParametrization', 'Entity.Activity.HasSpecificParametrization')
    .build(),
  FieldBuilder
    .checkbox('canAcceptConsumable', 'Entity.Activity.CanAcceptConsumable')
    .build(),
  FieldBuilder
    .checkbox('forRetroCompatibility', 'Entity.Activity.ForRetroCompatibility')
    .build(),
  FieldBuilder
    .foreignKey('wbsId', 'Entity.Wbs', WbsService)
    .required()
    .displayFromNested('wbs.name')
    .sortBy('wbs.name')
    .build(),
];

export const ACTIVITY_CONFIG = {
  entityName: 'Activity',
  localizationKey: 'Controlling::Entity.Activity',
  fields: ACTIVITY_FIELDS,
  permission: 'ControllingActivities.Activities',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'ActivityPerStage',
      foreignKeyField: 'activityId',
      localizationKey: 'Controlling::Entity.ActivityPerStage',
      component: ActivityPerStage,
    },
    {
      entityName: 'LevelPerActivity',
      foreignKeyField: 'activityId',
      localizationKey: 'Controlling::Entity.LevelPerActivity',
      component: LevelPerActivity,
    },
    {
      entityName: 'DocumentTypePerActivity',
      foreignKeyField: 'activityId',
      localizationKey: 'Controlling::Entity.DocumentTypePerActivity',
      component: DocumentTypePerActivity,
    },
    {
      entityName: 'ActivityProcessParametrization',
      foreignKeyField: 'activityId',
      localizationKey: 'Controlling::Entity.ActivityProcessParametrization',
      component: ActivityProcessParametrization,
    },
    {
      entityName: 'ConsumableAcceptedPerActivity',
      foreignKeyField: 'activityId',
      localizationKey: 'Controlling::Entity.ConsumableAcceptedPerActivity',
      component: ConsumableAcceptedPerActivity,
    },
  ]
};
